import React from "react";
import { motion } from "framer-motion";

/**
 * Fragment reveal wrapper.
 * - active: index of currently revealed fragment
 * - index:  this fragment's position
 * Previous fragments dim and shrink slightly, current is emphasized,
 * future fragments don't render at all.
 */
export const Fragment = ({ index, active, children, className = "" }) => {
    if (index > active) return null;
    const isCurrent = index === active;

    return (
        <motion.div
            initial={{ opacity: 0, y: 28, filter: "blur(8px)" }}
            animate={{
                opacity: isCurrent ? 1 : 0.42,
                y: 0,
                scale: isCurrent ? 1 : 0.985,
                filter: "blur(0px)",
            }}
            transition={{
                duration: 0.7,
                ease: [0.22, 1, 0.36, 1],
            }}
            className={className}
        >
            {children}
        </motion.div>
    );
};

export default Fragment;
